import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "../initialState.js";
import { getTariffs, generateInvoice, generateBalanceTopupInvoice, getBalanceUsageDetails, getServicesUsagePrices } from "./operations.js";

// const handlePending = state => {
//   state.isLoading = true;
//   state.error = null;
// };

// const handleRejected = (state, action) => {
//   state.isLoading = false;
//   state.error = action.payload;
// };

const tariffsSlice = createSlice({
  name: "tariffs",
  initialState: initialState.tariffs,
  reducers: {},
  extraReducers: builder =>
    builder
      .addCase(getTariffs.pending, state => {
        state.tariffsLoading = true;
        state.error = null;
      })
      .addCase(getTariffs.fulfilled, (state, action) => {
        state.tariffsLoading = false;
        state.listOfTariffs = action.payload;
      })
      .addCase(getTariffs.rejected, (state, action) => {
        state.tariffsLoading = false;
        state.error = action.payload;
      })

      // Generate Stripe Invoice +
      .addCase(generateInvoice.pending, state => {
        state.invoiceDataLoading = true;
        state.error = null;
      })
      .addCase(generateInvoice.fulfilled, (state, action) => {
        state.invoiceDataLoading = false;
        state.invoiceData = action.payload;
      })
      .addCase(generateInvoice.rejected, (state, action) => {
        state.invoiceDataLoading = false;
        state.error = action.payload;
      })

      // Generate Balane Top-up Invoice +
      .addCase(generateBalanceTopupInvoice.pending, state => {
        state.invoiceDataLoading = true;
        state.error = null;
      })
      .addCase(generateBalanceTopupInvoice.fulfilled, state => {
        state.invoiceDataLoading = false;
      })
      .addCase(generateBalanceTopupInvoice.rejected, (state, action) => {
        state.invoiceDataLoading = false;
        state.error = action.payload;
      })

      // Get Services Usage Prices +
      .addCase(getServicesUsagePrices.pending, state => {
        state.balanceUsageDetailsLoading = true;
        state.error = null;
      })
      .addCase(getServicesUsagePrices.fulfilled, (state, action) => {
        state.balanceUsageDetailsLoading = false;
        state.serviceUsagePrices = action.payload;
      })
      .addCase(getServicesUsagePrices.rejected, (state, action) => {
        state.balanceUsageDetailsLoading = false;
        state.error = action.payload;
      })

      // Get Balance Usage Details +
      .addCase(getBalanceUsageDetails.pending, state => {
        state.balanceUsageDetailsLoading = true;
        state.error = null;
      })
      .addCase(getBalanceUsageDetails.fulfilled, (state, action) => {
        state.balanceUsageDetailsLoading = false;
        state.balanceUsageDetails = action.payload;
      })
      .addCase(getBalanceUsageDetails.rejected, (state, action) => {
        state.balanceUsageDetailsLoading = false;
        state.error = action.payload;
      }),
});

export default tariffsSlice.reducer;
